import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[appDecimalLengthValidate][ngModel]',
  providers: [{ provide: NG_VALIDATORS, useExisting: DecimalLengthValidateDirective, multi: true }],
})
export class DecimalLengthValidateDirective implements Validator {
  @Input() leftLength: string;
  @Input() rightLength: string;

  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (
      value == null ||
      value == '' ||
      this.leftLength == null ||
      this.leftLength == '' ||
      this.rightLength == null ||
      this.rightLength == ''
    )
      return;

    if (isNaN(parseFloat(value)) || isNaN(parseInt(this.leftLength)) || isNaN(parseInt(this.rightLength))) return;

    const leftLen = parseInt(this.leftLength);
    const rightLen = parseInt(this.rightLength);

    const validationKey = 'decimallength';

    const decParts = value.toString().split('.');

    let part = decParts[0].replace(',', '').replace('-', '');
    if (part.length > leftLen) return { [validationKey]: true };

    if (decParts.length == 1) return;

    part = decParts[1].replace(',', '').replace('-', '');
    if (part.length > rightLen) return { [validationKey]: true };

    return null;
  }
}
